<template>

<app-content :loading="is.loading" :class="{'is-not-ongoing': !isOngoing}">

	<app-content-body :is-grid="4">

		<com-event class="dashboard-event" :data="data" />
		<com-calendar class="dashboard-calendar" :data="data" />
		<app-widget-activity title="Latest activity" id="all" class="dashboard-activity" />
		<com-looking class="dashboard-looking" v-if="isOngoing" />
		<app-widget-events title="Recently scheduled events" id="all" v-if="$isBadgeActive" class="dashboard-events" />

	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	components: {
		'com-looking': () => import('./conventiondashboard/Looking'),
		'com-event': () => import('./conventiondashboard/Event'),
		'com-calendar': () => import('./conventiondashboard/Calendar')
	},

	data: function() {

		return {
			is: {
				loading: true
			},
			data: {
				totals: [],
				events: []
			}
		}

	},

	created: function() {

		this.load()

	},

	computed: {
	
		isOngoing: function() {
		
			return this.$con.start <= this.$time - this.$con.offset && this.$con.end >= this.$time - this.$con.offset
		
		}

	},

	methods: {

		load: function() {

			this.$api.get('convention/dashboard').then(function(json) {

				Vue.set(this, 'data', json)

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.dashboard-event {
	grid-column: 1 / 2;
	order: 1;
}

.dashboard-calendar {
	grid-column: 2 / 5;
	order: 2;
}

.dashboard-activity {
	grid-column: 1 / 3;
	min-height: 240px;
	order: 3;
}

.is-not-ongoing .dashboard-activity {
	grid-column: 1 / 5;
}

.dashboard-looking {
	grid-column: 3 / 5;
	min-height: 240px;
	order: 4;
}

.dashboard-events {
	grid-column: 1 / 5;
	order: 5;
}

.is-small-desktop .dashboard-event {
	grid-column: 1 / 3;
}

.is-small-desktop .dashboard-calendar {
	grid-column: 1 / 5;
	order: 3;
}

.is-small-desktop .dashboard-looking {
	order: 2;
}

.is-small-desktop .dashboard-activity {
	grid-column: 1 / 5;
}

.is-small-desktop .is-not-ongoing .dashboard-activity {
	grid-column: 3 / 5;
	order: 2;
}

.is-mobile .dashboard-event,
.is-mobile .dashboard-calendar,
.is-mobile .dashboard-activity,
.is-mobile .dashboard-looking,
.is-mobile .dashboard-events {
	grid-column: 1 / 5;
}

.is-mobile .dashboard-activity {
	order: 4;
}

.is-mobile .dashboard-looking {
	order: 3;
	margin-bottom: 15px!important;
}

</style>